<template>
	<transition name="scroll-y-reverse-transition" v-if="module">
		<v-row v-show="module && salons.length" class="module" align="center">
			<v-container class="pb-0 primary--text">
				<div v-if="module.title" class="">
					<h2 class="display-1 mb-3">
						{{ module.title }}
					</h2>
				</div>
				<div v-if="module.subTitle">
					<p>
						{{ module.subTitle }}
					</p>
				</div>
			</v-container>

			<last-visited-salons-desktop v-show="$vuetify.breakpoint.mdAndUp" :module="module" :salons="salons"></last-visited-salons-desktop>
			<last-visited-salons-mobile v-show="$vuetify.breakpoint.smAndDown" :module="module" :salons="salons"></last-visited-salons-mobile>
		</v-row>
	</transition>
</template>

<script>
import LastVisitedSalonsDesktop from './LastVisitedSalonsDesktop';
import LastVisitedSalonsMobile from './LastVisitedSalonsMobile';
import { User } from '@fixit/fixit-no-header/src/models'; // @fixit/fixit-no-header

export default {
	name: 'last-visited-salons-module',
	props: ['module'],
	components: {
		LastVisitedSalonsDesktop,
		LastVisitedSalonsMobile
	},
	created() {
		if(this.user.onlinesluttkundeId) this.fetchLastVisitedSalons();
	},
	data() {
		return {
			imgIsLoaded: false
		};
	},
	computed: {
		user() {
				return new User(this.$user);
			},
		salons() {
			return this.user.onlinesluttkundeId? this.$store.getters['user/getLastVisitedSalons'](this.module.numberOfSalonsDisplayed || 3): [];
		}
	},
	methods: {
		async fetchLastVisitedSalons() {
			// Only fetch data when empty
			if (!this.salons.length) {
				await this.$store.dispatch('user/getLastVisitedSalons');
			}
		},
		linkUrl(linkArray) {
			if (!linkArray) {
				return '';
			}
			return linkArray[0].link;
		},
		imageSrc(image, crop) {
			if (!image.imageCrops) {
				return '';
			}
			const cropItem = image.imageCrops.find(ic => ic.alias == crop);
			return cropItem ? cropItem.cropUrl : '';
		},
		goToUrl(link) {
			if (link.length) {
				window.location.href = link[0].link;
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.module {
	margin-bottom: 100px;

	@media #{map-get($display-breakpoints, 'xs-only')} {
		margin-bottom: 50px;
		h2 {
			font-size: 1.5rem !important;
		}
	}
}
</style>
